import PropTypes from "prop-types";

const InsuranceButton = ({ onClick, text = "" }) => {
  return (
    <button
      type="button"
      onClick={() => onClick()}
      className={"option-button button__filled"}
    >
      {text}
    </button>
  );
};

InsuranceButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default InsuranceButton;
